import { MonthBudgetBasedHouseAffordability } from "../Apps/MonthBudgetBasedHouseAffordability"

function AppMonthBudgetBasedHouseAffordability() {

  return (
    <MonthBudgetBasedHouseAffordability />
  )
}

export default AppMonthBudgetBasedHouseAffordability

